export default __webpack_public_path__ + "static/media/respuesta.4c79d1c2.png";